<template>
  <div class="staffStatistics">
    <search
      :options="option"
      @searchBtn="searchBtn"
      @changeValue="changeValue"
      :inputAndSelectShow="true"
      :placeholder1="placeholder1"
      :placeholder2="placeholder2"
    ></search>

    <div class="paixu">
      <el-select v-model="value" @change="paixu" placeholder="综合排序">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <timeChuli class="timeChuli" @btnClick="timeClick"></timeChuli>

    <dataTable
      ref="dataTable"
      :flush="fresh"
      :inSerachFilte="inSerachFilte"
      :inTableData="tableDataConfig"
      :inAjax="tableAjaxConfig"
      :ispagination="true"
      :isAjax="isAjax"
      @rowClick="tableClickConfig"
    ></dataTable>
  </div>
</template>

<script>
  import timeChuli from "../components/timeChuli";
  import search from "../components/search";
  import dataTable from "../../components/commonComponents/dataTable";
  import GlobalUtil from "../../utils/globalUtil.js";

  export default {
    components: {
      timeChuli,
      search,
      dataTable
    },
    data() {
      return {
        isAjax: false,
        option: [],
        options: [
          {
            label: "销售总额",
            value: "orderAmount "
          },
          {
            label: "订单数",
            value: "orderCount"
          },
          {
            label: "客户数量",
            value: "customCount"
          }
        ],
        value: "",
        placeholder1: "请选择部门/小组",
        placeholder2: "请输入销售姓名",
        //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
        fresh: "",
        // 用于匹配搜索数据，返回新的数据
        inSerachFilte: {},
        //tableData组件参数配置
        tableDataConfig: {
          //表头及字段配置
          tHead: [
            {
              name: "销售头像",
              field: "avatarUrl",
              type: "image",
              width: 100,
              click: false
            },
            {
              name: "销售姓名",
              field: "realName"
            },
            {
              name: "所在部门或小组",
              field: "orgName"
            },
            {
              name: "累计客户（人）",
              field: "customCount"
            },
            {
              name: "累计订单数（单）",
              field: "orderCount"
            },
            {
              name: "累计销售额（元）",
              field: "orderAmount"
            },
            {
              name: "入职时间",
              field: "createDate"
            },
            {
              name: "操作",
              type: "actionBtns", //配置操作按钮actionSelectBtns为下拉按钮，actionBtns为平铺按钮
              field: "sendDate",
              callback: function (v, row) {
                let arr = [
                  {
                    type: "detail",
                    label: "<span>查看详情</span>"
                  }
                ];
                return arr;
              }
            }
          ],
          //自动渲染
          tData: [],
          //自动渲染
          total: 0,
          actionBtWidth: "250",
          //配置是否显示多选框
          isMultiple: false,
          dispatchp: true,
          //配置是否显示排序
          isRank: true
        },
        tableAjaxConfig: {
          url: this.$url.getMemberSalesList,
          method: "post",
          data: {
            pageNumber: 1,
            pageSize: 15,
            queryObj: {}
          }
        },
        orgId: "",
        searchObj: {}
      };
    },
    created() {
      this.$axios.post(this.$url.list, {}).then(res => {
        if (res.code === 0) {
          let ids = res.data.map(_ => {
            return _.id;
          });
          this.option = res.data.map(_ => {
            let obj = {
              label: _.name,
              value: _.id
            };
            return obj;
          });
          this.isAjax = true
          this.inSerachFilte = {queryObj: this.searchObj};
        }
      });
    },
    methods: {
      changeValue(e) {
        this.searchObj["orgId"] = e || null;
        this.inSerachFilte = {queryObj: this.searchObj};
      },
      paixu(e) {
        this.searchObj["orderFlag"] = e;
        this.inSerachFilte = {queryObj: this.searchObj};
      },
      timeClick(e) {
        this.searchObj["timeFlag"] = e;
        this.inSerachFilte = {queryObj: this.searchObj};
      },
      searchBtn(e) {
        this.searchObj["itemNbrOrName"] = e;
        this.inSerachFilte = {queryObj: this.searchObj};
      },
      tableClickConfig(data) {
        console.log("1232", data.rowData);
        if (data.type == "detail") {
          this.$router.push({
            name:'databoardstatisticsdetail'
          });
          GlobalUtil.setCookie("salesInfo", JSON.stringify(data.rowData));
        }
      },
      // 获取销售部门
      getOrgList() {
      }
    }
  };
</script>

<style lang='less' scoped>
  .staffStatistics {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 24px 30px;
    position: relative;

    .timeChuli {
      position: absolute;
      right: 0px;
      top: 27px;
    }

    .paixu {
      position: absolute;
      right: 400px;
      top: 28px;
      width: 100px;

      ::v-deep .el-input__inner {
        padding-left: 10px !important;
        height: 29px;
      }

      ::v-deep .el-select__caret {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
